// Port of api/fuel/app/classes/insights/worth/publishers.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function roundWorth(value) {
	return Math.round(parseFloat(value) || 0)
}

export default Segment.extend({
	name: 'publishers',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['publishers'],
	run: function(type, owner, userIndex, detail, filter) {
		if (!owner.get_count_collection()) return {}

		var limit = detail ? 100 : 5
		var mode = (filter && filter.publishers) ? filter.publishers : 'total'
		var ranked = []
		var versioning = {
			versions: [-1],
			games: []
		}
		var versionRows = Util.queryFast(
			'SELECT c.game_id AS g, c.game_version_id AS v FROM collection c' +
			' WHERE c.collection_own = 1 AND c.user_id IN(' + Util.in(userIndex) + ')'
		)

		for (var i = 0; i < versionRows.length; i++) {
			var row = versionRows[i]
			var versionId = parseInt(row.v, 10) || 0
			if (versionId) versioning.versions.push(versionId)
			else versioning.games.push(parseInt(row.g, 10))
		}

		if (!versioning.games.length) versioning.games.push(-1)

		var sorted = Util.queryFast(
			'SELECT GROUP_CONCAT(DISTINCT g.game_id ORDER BY g.game_id ASC) AS i,' +
			' COUNT(DISTINCT(g.game_id)) AS g, d.publisher_id AS d,' +
			' ' + (mode === 'total' ? 'SUM' : 'AVG') + '(COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)) AS w' +
			' FROM game g, game_publisher d LEFT JOIN game_version v ON v.game_version_id = d.game_version_id' +
			' WHERE d.game_publisher_primary = 1' +
			' AND ((d.game_id IN(' + Util.in(versioning.games) + ') AND d.game_version_id = 0)' +
			' OR d.game_version_id IN(' + Util.in(versioning.versions) + '))' +
			' AND g.game_worth_value > 0' +
			' AND g.game_id = d.game_id' +
			' AND g.game_type = ' + Constants.GAME_TYPE_BASE +
			' GROUP BY d.publisher_id' +
			(mode === 'average' ? ' HAVING COUNT(DISTINCT(d.game_id)) > 1' : '') +
			' ORDER BY w DESC LIMIT 0, ' + limit
		)

		var index = []
		var grouped = {}
		var allGameIds = []

		for (var j = 0; j < sorted.length; j++) {
			var item = sorted[j]
			var publisherId = parseInt(item.d, 10)
			var itemIndex = item.i ? item.i.split(',') : []
			grouped[publisherId] = []
			index.push(publisherId)

			for (var g = 0; g < itemIndex.length; g++) {
				var gameId = parseInt(itemIndex[g], 10)
				if (!gameId) continue
				grouped[publisherId].push(gameId)
				allGameIds.push(gameId)
			}
		}

		// per-game worth lookup (deterministic — avoids the GROUP_CONCAT alignment
		// bug that arises when a game has multiple matching publisher rows).
		var worthByGameId = {}
		if (allGameIds.length) {
			var worthRows = Util.queryFast(
				'SELECT g.game_id AS gid,' +
				' MAX(COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)) AS gw' +
				' FROM game g, game_publisher d LEFT JOIN game_version v ON v.game_version_id = d.game_version_id' +
				' WHERE d.game_publisher_primary = 1' +
				' AND ((d.game_id IN(' + Util.in(versioning.games) + ') AND d.game_version_id = 0)' +
				' OR d.game_version_id IN(' + Util.in(versioning.versions) + '))' +
				' AND g.game_worth_value > 0' +
				' AND g.game_id = d.game_id' +
				' AND g.game_type = ' + Constants.GAME_TYPE_BASE +
				' AND g.game_id IN(' + Util.in(allGameIds) + ')' +
				' GROUP BY g.game_id'
			)
			for (var wi = 0; wi < worthRows.length; wi++) {
				worthByGameId[worthRows[wi].gid] = worthRows[wi].gw
			}
		}

		if (index.length) {
			// Raw query instead of Publisher.indexed() (which builds Model objects).
			var detailRows = Util.queryFast(
				'SELECT publisher_id, publisher_name FROM publisher WHERE publisher_id IN(' + Util.in(index) + ')'
			)
			var details = {}
			for (var dri = 0; dri < detailRows.length; dri++) {
				details[detailRows[dri].publisher_id] = detailRows[dri]
			}

			for (var k = 0; k < sorted.length; k++) {
				var entry = sorted[k]
				var id = parseInt(entry.d, 10)
				var gameWorths = []

				for (var gi = 0; gi < grouped[id].length; gi++) {
					var currentGameId = grouped[id][gi]
					gameWorths.push({
						id: currentGameId,
						worth: roundWorth(worthByGameId[currentGameId])
					})
				}

				gameWorths = gameWorths.slice().sort(function(a, b) { return a.worth !== b.worth ? b.worth - a.worth : a.id - b.id })

				for (var r = 0; r < 3 && r < gameWorths.length; r++) this._references.games.push(gameWorths[r].id)

				var det = details[id]
				ranked.push({
					id: det ? (det.publisher_id | 0) : id,
					name: det ? (det.publisher_name || '') : '',
					worth: roundWorth(entry.w),
					count: parseInt(entry.g, 10) || 0,
					games: gameWorths.slice(0, 3)
				})
			}
		}

		return {
			publishers: ranked
		}
	}
})
